import clsx from 'clsx';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { checkIfValidUUID, useLayout, usePageData } from '../../../layout/core';
import { useTranslation } from 'react-i18next';
import { CopyComponent } from '../../CopyComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { WhisperComponent } from '../../developers/page-components/WhisperComponent';

const DefaultTitle: FC = () => {
	const { pageTitle, pageDescription, pageBreadcrumbs } = usePageData();
	const { config, classes } = useLayout();
	const { t } = useTranslation();

	const breadCrumbsCondition =
		pageBreadcrumbs &&
		pageBreadcrumbs.length > 0 &&
		config.pageTitle &&
		config.pageTitle.breadCrumbs;

	const showCopyButton = checkIfValidUUID(pageTitle);

	return (
		<div
			id="kt_page_title"
			data-kt-swapper="true"
			data-kt-swapper-mode="prepend"
			data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
			className={clsx('page-title d-flex', classes.pageTitle.join(' '))}
		>
			{/* begin::Title */}
			{!breadCrumbsCondition && pageTitle && (
				<h1 className="d-flex align-items-center text-dark fw-bolder my-1 fs-3">
					{pageTitle}
					{pageDescription && config.pageTitle && config.pageTitle.description && (
						// <>
						// 	<span className="h-20px border-gray-200 border-start ms-3 mx-2"/>
						// 	<small className="text-muted fs-7 fw-bold my-1 ms-1">
						// 		{pageDescription}
						// 	</small>
						// </>
						<WhisperComponent
							isTooltip
							whisperText={pageDescription}
							placement='bottom'
							mainText={
								<FontAwesomeIcon
									icon={faQuestionCircle}
									className="cursor-pointer ms-2"
									width={14}
								/>
							}
						/>
					)}
				</h1>
			)}
			{/* end::Title */}

			{breadCrumbsCondition && (
				<>
					{/*{config.pageTitle!.direction === 'row' && (*/}
					{/*	<span className="h-20px border-gray-200 border-start mx-4"/>*/}
					{/*)}*/}
					<ul className="breadcrumb breadcrumb-separatorless fw-bold fs-3 my-1">
						{Array.from(pageBreadcrumbs)?.map((item, index) => (
							<li
								className={clsx('breadcrumb-item', {
									'text-dark': !item.isSeparator && item.isActive,
									'text-muted': !item.isSeparator && !item.isActive
								})}
								key={`${item.path}${index}`}
								data-cy="breadcrumb-item"
							>
								{!item.isSeparator ? (
									<Link className="text-muted text-hover-primary" to={item.path}>
										{t(item.title)}
									</Link>
								) : (
									<span className="bullet bg-gray-200 w-5px h-2px"/>
								)}
							</li>
						))}
						<li className="breadcrumb-item text-dark fw-bold" data-cy="breadcrumb-item">
							<div className="d-flex align-items-center">
								<div>
									{pageTitle}
								</div>
								{
									showCopyButton && (
										<CopyComponent value={pageTitle} title="Id" additionalClass="ms-3"/>
									)
								}
							</div>
						</li>
					</ul>
				</>
			)}
		</div>
	);
};

export { DefaultTitle };
